import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Icon,
  IconButton,
  Menu,
  MenuItem,
  Popover,
  Typography,
} from '@mui/material';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine-dark.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';
import {
  useMainFrameDispatch,
  useMainFrameState,
} from '../../../MainUIFrame/MainFrame';
import { useCallback, useEffect, useRef, useState } from 'react';
import { ehrAPIBaseService } from '../../../../http-common';
import _, { isEmpty } from 'lodash';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import {
  ACTION_OPEN_RIGHT_FLOATING_DRAWER,
  ACTION_RIGHT_DRAWER,
  ACTION_RIGHT_DRAWER_JSX,
} from '../../../MainUIFrame/constants';
import UpdateSingleTaskRightDrawer from './UpdateSingleTaskRightDrawer';
import AddTaskRightDrawer from './AddTaskRightDrawer';
import { useParams } from 'react-router-dom';

const ThreeDotsCellRenderer = params => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  if (params?.data?.taskType === 'no_data_found') return null;

  return (
    <Box variant="div">
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <Icon>more_vert</Icon>
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem onClick={handleClose}>Send a Reminder</MenuItem>
      </Menu>
    </Box>
  );
};

const TASK_STATUS_LIST = [
  {
    code: 'requested',
    display: 'Requested',
  },
  {
    code: 'received',
    display: 'Received',
  },
  {
    code: 'accepted',
    display: 'Accepted',
  },
  {
    code: 'rejected',
    display: 'Rejected',
  },
  {
    code: 'ready',
    display: 'Ready',
  },
  {
    code: 'cancelled',
    display: 'Cancelled',
  },
  {
    code: 'in-progress',
    display: 'In Progress',
  },
  {
    code: 'on-hold',
    display: 'On Hold',
  },
  {
    code: 'failed',
    display: 'Failed',
  },
  {
    code: 'completed',
    display: 'Completed',
  },
  {
    code: 'entered-in-error',
    display: 'Entered in Error',
  },
];

const TaskScreenList = props => {
  const { isDark } = useMainFrameState();
  const dispatch = useMainFrameDispatch();
  const gridRef = useRef(null);
  const currentPatientObject = useSelector(
    state => state?.current?.currentPatientObject
  );
  const patId = useParams().id;

  const [isGridLoading, setIsGridLoading] = useState(false);

  const NoRowsOverlay = () => {
    return (
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        No data found
      </div>
    );
  };

  const columnData = [
    {
      field: 'taskType',
      headerName: 'Task Type',
      flex: 1,
      suppressMovable: true,
      cellRenderer: params => {
        if (
          params?.data?.taskType &&
          params?.data?.taskType !== 'no_data_found'
        ) {
          return params?.data?.taskType;
        }

        if (params?.value === 'no_data_found') {
          return <div>No Data Found</div>;
        }

        if (!isEmpty(params?.data) && params?.data?.taskType === undefined) {
          return (
            <div style={{ color: 'red', fontSize: '9px' }}>
              Data not entered
            </div>
          );
        }

        // if (
        //   params?.data?.taskType &&
        //   params?.data?.taskType !== 'no_data_found'
        // ) {
        //   return params?.data?.taskType;
        // }

        // if (
        //   params?.data?.taskType &&
        //   params?.data?.taskType === 'no_data_found'
        // ) {
        //   return <div>{`No Data Found`}</div>;
        // }
        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-around',
              marginTop: 1,
            }}
          >
            <CircularProgress
              sx={{ display: 'flex' }}
              style={{ marginRight: 10 }}
              size={20}
            />
            <Typography> Loading...</Typography>
          </Box>
        );
      },
    },
    {
      field: 'taskName',
      headerName: 'Type',
      flex: 1,
      suppressMovable: true,
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      suppressMovable: true,
    },
    {
      field: 'assignedBy',
      headerName: 'Assigned By',
      flex: 1,
      suppressMovable: true,
    },
    {
      field: 'dueDate',
      headerName: 'Due Date',
      flex: 1,
      suppressMovable: true,
    },
    {
      field: 'authoredOn',
      headerName: 'Requested Date',
      flex: 1,
      suppressMovable: true,
    },
    {
      field: 'lastUpdated',
      headerName: 'Last Updated',
      flex: 1,
      suppressMovable: true,
    },
    // {
    //   field: 'threeDots',
    //   headerName: 'Actions',
    //   flex: 0.4,
    //   cellRenderer: 'threeDotsCellRenderer',
    // },
  ];

  let realTotalPage = 0;

  let openPageToken = '';

  const gridRefreshCallback = () => {
    gridRef?.current?.api?.setDatasource(dataSource());
  };

  // const gridRefreshCallback = useCallback(() => {
  //   gridRef?.current?.api?.setDatasource(dataSource());
  // }, []);

  const handleOnClick = event => {
    const { name, value } = event?.target;
    if (name === 'openCurrentTask') {
      const { currentItem } = value;

      dispatch({
        type: ACTION_RIGHT_DRAWER_JSX,
        payload: (
          <UpdateSingleTaskRightDrawer
            task={currentItem}
            gridRefreshCallback={gridRefreshCallback}
          />
        ),
      });

      dispatch({ type: ACTION_OPEN_RIGHT_FLOATING_DRAWER });
    }

    if (name === 'assignTask') {
      dispatch({
        type: ACTION_RIGHT_DRAWER_JSX,
        payload: (
          <AddTaskRightDrawer gridRefreshCallback={gridRefreshCallback} />
        ),
      });

      dispatch({ type: ACTION_OPEN_RIGHT_FLOATING_DRAWER });
    }
  };

  const dataSource = () => {
    return {
      async getRows(params) {
        const { startRow, endRow, filterModel, sortModel } = params;
        let url = `fhir/search/`;
        let _resourseType = `Task`;
        let _pageToken = `_page_token=${openPageToken}`;
        let _offset = `_offset=${parseInt(startRow + 1)}`;
        let _count = `_count=${parseInt(endRow - startRow)}`;
        let _sort = `_sort=-lastUpdated`;
        let newParams = `code=http://enliv.com/code/task-type|other,questionaireForm,fillGenericForm,uploadDocuments,intakeForm`;

        url += `${_resourseType}?${_offset}&${_count}&${_sort}&${newParams}&patient=${
          currentPatientObject?.id ? currentPatientObject?.id : patId
        }`;

        if (!_.isEmpty(openPageToken) && endRow > 10) {
          url += `&${_pageToken}`;
        }

        let tempRows = [];

        try {
          const response = await ehrAPIBaseService.get(url);

          tempRows = response?.data?.entry?.map(taskEntry => {
            const task = taskEntry?.resource;
            return {
              currentItem: task,
              taskType: task?.code?.coding?.find(item =>
                item?.system?.includes(`task-type`)
              )?.display,
              taskName: task?.code?.coding?.find(item =>
                item?.system?.includes(`sub-task-type`)
              )?.display,
              status: TASK_STATUS_LIST?.find(o => o?.code === task?.status)
                ?.display,
              dueDate: dayjs(task?.executionPeriod?.end)?.format(`MM/DD/YYYY`),
              authoredOn: dayjs(task?.authoredOn)?.format(`MM/DD/YYYY HH:mm`),
              assignedBy: task?.owner?.display,
              lastUpdated: dayjs(task?.meta?.lastUpdated)?.format(
                `MM/DD/YYYY HH:mm`
              ),
            };
          });

          for (let obj of response?.data?.link) {
            if (obj?.relation === 'next') {
              let tempPageToken = obj?.url?.split('_page_token=')?.[1];
              openPageToken = tempPageToken;
            }
          }

          if (tempRows?.length > 0) {
            params.successCallback(
              tempRows,
              realTotalPage === 0 ? response?.data?.total : realTotalPage
            );
          } else {
            params.successCallback([{ taskType: 'no_data_found' }], 1);
          }

          if (realTotalPage === 0) {
            realTotalPage = response?.data?.total;
          }
        } catch (e) {
          console.error(e);
          params.successCallback([{ taskType: 'no_data_found' }], 1);
        } finally {
        }
      },
    };
  };

  const onGridReady = params => {
    params.api.setDatasource(dataSource());
  };

  useEffect(() => {
    dispatch({ type: ACTION_RIGHT_DRAWER });
  }, []);

  useEffect(() => {
    if (gridRef?.current) {
      gridRefreshCallback();
    }
  }, [gridRefreshCallback]);

  return (
    <Grid container>
      <Grid item sm={12} p={3}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            p: 2,
            backgroundColor: 'primary.main',
            color: 'white',
            borderTopLeftRadius: '16px',
            borderTopRightRadius: '16px',
          }}
        >
          <Typography>All - Task</Typography>
          <Button
            sx={{
              background: 'white',
              color: 'primary.main',
              '&:hover': {
                color: '#ffffff',
                backgroundColor: 'primary.main',
              },
            }}
            variant="contained"
            name="assignTask"
            onClick={handleOnClick}
          >
            Assign Task
          </Button>
        </Box>
        <Box
          className={isDark ? `ag-theme-custom ` : `ag-theme-alpine `}
          sx={{ overflow: 'auto', height: `70vh` }}
        >
          <AgGridReact
            domLayout="autoHeight"
            ref={gridRef}
            columnDefs={columnData}
            rowSelection={'single'}
            paginationPageSize={10}
            rowModelType="infinite"
            cacheBlockSize={10}
            cacheOverflowSize={2}
            maxConcurrentDatasourceRequests={2}
            infiniteInitialRowCount={1}
            maxBlocksInCache={2}
            components={{
              threeDotsCellRenderer: ThreeDotsCellRenderer,
              noRowsOverlay: NoRowsOverlay,
            }}
            noRowsOverlayComponent="noRowsOverlay"
            onRowDoubleClicked={event => {
              let selectedRow = event?.data;
              if (event?.data?.taskType === 'no_data_found') return;
              handleOnClick({
                target: {
                  name: 'openCurrentTask',
                  value: { currentItem: selectedRow?.currentItem },
                },
              });
            }}
            pagination={true}
            animateRows={true}
            onGridReady={onGridReady}
          />
        </Box>
      </Grid>
    </Grid>
  );
};
export default TaskScreenList;
